<template>
    <div>
        <el-divider>{{$t('私有属性')}}</el-divider>
        <el-form-item :label="$t('查询接口')">
            <el-input v-model="data.dataApi" placeholder="例如：'/mes/workordertasks/{val}', val为输入值"></el-input>
        </el-form-item>
        <el-divider>{{$t('主表数据映射')}}</el-divider>
        <!-- <el-form-item :label="$t('数据映射表')"> -->
            <div>
                <div v-for="(item, index) in data.dataTable"
                    class="set-item"
                    :key="index">
                    <!-- <i class="drag-item el-icon-rank"></i> -->
                    <l-select size="mini" :options="valueOptions.mainList" :disabledList="vals.join(',')" placehoder="主表组件" style="width:49%;margin-right:2%;" v-model="item.prop"></l-select>
                    <el-input
                        style="width:49%;"
                        size="mini"
                        v-model="item.key"
                        :placeholder="$t('绑定字段')"></el-input>
                    <el-button
                        @click="del(index)"
                        circle
                        plain
                        type="danger"
                        size="mini"
                        icon="el-icon-minus"
                        class="delete-item"
                        style="padding: 4px;"></el-button>
                </div>
                <div style="padding-left:22px;" v-if="data.dataTable.length < valueOptions.mainList.length">
                    <el-button size="mini" type="text" icon="el-icon-circle-plus-outline" @click="add"  >{{$t('添加关联组件')}}</el-button>
                </div>
            </div>
        <!-- </el-form-item> -->
        <template v-if="valueOptions.gridtableList.length">
            <el-divider>{{$t('子表数据映射')}}</el-divider>
            <div>
                <div v-for="(item, index) in data.dataChildTable"
                    class="set-item"
                    :key="index">
                    <!-- <i class="drag-item el-icon-rank"></i> -->
                    <l-select size="mini" :options="valueOptions.gridtableList" :disabledList="cvals.join(',')" placehoder="子表组件" style="width:49%;margin-right:2%;" v-model="item.prop"></l-select>
                    <el-input
                        style="width:49%;"
                        size="mini"
                        v-model="item.key"
                        :placeholder="$t('绑定字段')"></el-input>
                    <el-button
                        @click="delChild(index)"
                        circle
                        plain
                        type="danger"
                        size="mini"
                        icon="el-icon-minus"
                        class="delete-item"
                        style="padding: 4px;"></el-button>
                </div>
                <div style="padding-left:22px;" v-if="data.dataChildTable.length < valueOptions.gridtableList.length">
                    <el-button size="mini" type="text" icon="el-icon-circle-plus-outline" @click="addChild"  >{{$t('添加关联组件')}}</el-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "config-scanCode",
    props: ['data'],
    inject: ["formDesign"],
    data() {
        return {};
    },
    computed: {
        vals () {
            return this.data.dataTable.map(e => e.prop)
        },
        cvals () {
            return this.data.dataChildTable.map(e => e.prop)
        },
        valueOptions() {
            const res = {
                mainList: [],
                gridtableList: [],
            };
            const formInfo = this.formDesign.toSaveData();
            formInfo.tabList.forEach((tab) => {
                tab.components.forEach((com) => {
                if (
                    ![
                    "viewtable",
                    "card",
                    "btn",
                    "tab",
                    "collapse",
                    "divider",
                    "btn",
                    "tableLayout",
                    "guid",
                    "modifytime",
                    "modifyuser",
                    "createtime",
                    "createuser",
                    ].includes(com.type) &&
                    com.prop != this.data.prop
                ) {
                    res.mainList.push({ value: com.prop, label: com.label });
                    if (["gridtable"].includes(com.type)) {
                        com.children.forEach((c) => {
                        if (
                            c.prop != this.data.prop &&
                            ![
                            "guid",
                            "company",
                            "department",
                            "modifytime",
                            "modifyuser",
                            "createtime",
                            "createuser"
                            ].includes(c.type)
                        ) {
                            res.gridtableList.push({ value: `${com.prop}.${c.prop}`, label: c.label });
                        }
                        });
                    }
                }
                });
            });
            return res;
            },
    },
    mounted() {
        
    },
    methods: {
        del(index) {
            this.data.dataTable.splice(index, 1)
        },
        add () {
            let item = ''
            for (let i = 0;i < this.valueOptions.mainList.length;i++) {
                item = this.valueOptions.mainList[i]
                if (!this.vals.includes(item.value)) {
                    break
                }
            }
            this.data.dataTable.push({
                prop: item.value,
                key: ''
            })
        },
        delChild(index) {
            this.data.dataChildTable.splice(index, 1)
        },
        addChild () {
            let item = ''
            for (let i = 0;i < this.valueOptions.gridtableList.length;i++) {
                item = this.valueOptions.gridtableList[i]
                if (!this.cvals.includes(item.value)) {
                    break
                }
            }
            this.data.dataChildTable.push({
                prop: item.value,
                key: ''
            })
        }
    }
}
</script>
<style scoped>
    
</style>